<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent: 0em !important">“I wish to be a fairy with wings of fire</p>
<p style="text-indent: 0em !important">wings made of my anger that will never tire</p>
<p style="text-indent: 0em !important">wings so strong, they will never quiver</p>
<p style="text-indent: 0em !important">of hearing my reputation any soul will shiver</p>
<p style="text-indent: 0em !important">wings so sturdy no one will be able to hurt me</p>
<p style="text-indent: 0em !important">wings that can bring down anyone, no matter how mighty</p>
<p style="text-indent: 0em !important">wings that reach up above any mountain and to the sky</p>
<p style="text-indent: 0em !important">wings that will surge and in the greatest of heights fly</p>
<p style="text-indent: 0em !important">I wish to be a fairy made of the sun fire</p>
<p style="text-indent: 0em !important">I wish to be the true me that I desire</p>
<p style="text-indent: 0em !important">This book is about my struggles as the strange kid in every room I ever entered, and my fantasies of other worlds.”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?f1fe8ca4